// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aea1a0d9","455":"d6c49d7b"}[chunkId] + ".chunk.js";
};